const LAST_N_PHONE_DIGIT = 3;

export const getPhoneNumberMask = (phoneNumber: string, showLastNDigits = LAST_N_PHONE_DIGIT) => {
  return `***${phoneNumber.substring(phoneNumber.length - showLastNDigits)}`;
};
